
function Cancel() {
    return (
        <h1> Sorry to see you cancelled your stripe payment</h1>
    )
}
export default Cancel;